module.exports = __webpack_public_path__ + "static/media/error.c8ecb5ff.svg";